import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Machine } from '../../../shared/models/machine.model';
import { ConnectionCheck } from '../../../utils/connection-check';

@Component({
  selector: 'app-machines-list',
  templateUrl: './machines-list.component.html',
  standalone: false
})
export class MachineListComponent implements OnInit {
  @Input() public machines: Machine[];
  @Output() public toggleSelect: EventEmitter<any> = new EventEmitter();
  @Output() public toggleScroll: EventEmitter<any> = new EventEmitter();
  public orderByFieldName = 'serialNumber';
  public direction = 'desc';

  ngOnInit() {}

  public selectMachine(machine: Machine) {
    this.toggleSelect.emit(machine);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }

  get isConnection() {
    return ConnectionCheck.isConnection;
  }

  scroll(event: Event) {
    if (!this.isConnection) return;

    const target = event.target as HTMLDivElement;
    if (target.scrollHeight - target.clientHeight - target.scrollTop < 600) {
      this.toggleScroll.emit();
    }
  }
}
